<template>
  <div class="instructions">
    <div class="wrapper">
      <div class="description">
        <h1>Instrucciones</h1>
        <simon-game
          class="game"
          :demo-mode="true"
          :volume="volume"/>
        <ol>
          <li>El tablero mostrará una secuencia aleatória, iluminando los botones y reproduciendo un sonido por cada uno de ellos.</li>
          <li>Deberás repetir la secuencia, en el mismo orden, seleccionado los botones del tablero de acuerdo al color y sonido.</li>
          <li>La secuencia se hará más extensa con cada nivel que avances.</li>
          <li>Sólo tienes una oportunidad para lograr tu registro más alto y participar.</li>
        </ol>
      </div>
      <div class="button-wrapper">
        <button
          class="btn btn-primary btn-block"
          @click="activateSound"
        >Probar sonido</button>
        <button
          class="btn btn-primary btn-block"
          @click="close">¡Entendido!</button>
      </div>
    </div>
  </div>
</template>

<script>
import SimonGame from './../components/simon-game.vue'

export default {
  name: 'Instructions',
  components: {
    SimonGame
  },
  data () {
    return {
      volume: 0
    }
  },
  methods: {
    activateSound () {
      this.volume = 0.2
    },
    deactivateSound () {
      this.volume = 0
    },
    close () {
      this.volume = 0
      this.$emit('deactivateInnerView', 'instructions')
    }
  }
}
</script>

<style lang="scss" scoped>
.instructions {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: auto;
  .wrapper {
    max-width: 400px;
    height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .game {
      height: 40vh;
      max-height: 70vw;
      width: 40vh;
      max-width: 70vw;
      margin: 0px auto;
    }
    .description {
      color: #fff;
      h1 {
        text-align: center;
        text-transform: uppercase;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/simon-game/views/instructions-view.vue